<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { bindFullscreenIntentSync, initDefaultAppFullscreen } from '@/utils/appFullscreen'

let unbindFullscreenSync = null

export default {
  name: 'App',
  async mounted() {
    unbindFullscreenSync = bindFullscreenIntentSync()
    await initDefaultAppFullscreen()
  },
  unmounted() {
    unbindFullscreenSync?.()
    unbindFullscreenSync = null
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1.5;
  color: var(--mc-text-primary, #1a1d24);
  background: var(--mc-bg-page, #eef0f4);
  -webkit-font-smoothing: antialiased;
}

#app {
  min-height: 100vh;
  position: relative;
}
</style>
